module.exports = __webpack_public_path__ + "img/top1.f6d7beb3.jpg";